import { render } from "./WarehousePurchaseReceive.vue?vue&type=template&id=1bb1c4e9&scoped=true"
import script from "./WarehousePurchaseReceive.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseReceive.vue?vue&type=script&lang=js"

import "./WarehousePurchaseReceive.vue?vue&type=style&index=0&id=1bb1c4e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb1c4e9"]])

export default __exports__